import { queryParams, type RouteQueryOptions, type RouteDefinition, type RouteFormDefinition } from './../../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Web\BeautyShots\ShowBeautyShotGenerationStatusBatchController::__invoke
* @see Http/Controllers/Web/BeautyShots/ShowBeautyShotGenerationStatusBatchController.php:16
* @route '/ai-products/beauty-shot/status'
*/
const ShowBeautyShotGenerationStatusBatchController = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ShowBeautyShotGenerationStatusBatchController.url(options),
    method: 'post',
})

ShowBeautyShotGenerationStatusBatchController.definition = {
    methods: ["post"],
    url: '/ai-products/beauty-shot/status',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\Web\BeautyShots\ShowBeautyShotGenerationStatusBatchController::__invoke
* @see Http/Controllers/Web/BeautyShots/ShowBeautyShotGenerationStatusBatchController.php:16
* @route '/ai-products/beauty-shot/status'
*/
ShowBeautyShotGenerationStatusBatchController.url = (options?: RouteQueryOptions) => {
    return ShowBeautyShotGenerationStatusBatchController.definition.url + queryParams(options)
}

/**
* @see \App\Http\Controllers\Web\BeautyShots\ShowBeautyShotGenerationStatusBatchController::__invoke
* @see Http/Controllers/Web/BeautyShots/ShowBeautyShotGenerationStatusBatchController.php:16
* @route '/ai-products/beauty-shot/status'
*/
ShowBeautyShotGenerationStatusBatchController.post = (options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: ShowBeautyShotGenerationStatusBatchController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\BeautyShots\ShowBeautyShotGenerationStatusBatchController::__invoke
* @see Http/Controllers/Web/BeautyShots/ShowBeautyShotGenerationStatusBatchController.php:16
* @route '/ai-products/beauty-shot/status'
*/
const ShowBeautyShotGenerationStatusBatchControllerForm = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ShowBeautyShotGenerationStatusBatchController.url(options),
    method: 'post',
})

/**
* @see \App\Http\Controllers\Web\BeautyShots\ShowBeautyShotGenerationStatusBatchController::__invoke
* @see Http/Controllers/Web/BeautyShots/ShowBeautyShotGenerationStatusBatchController.php:16
* @route '/ai-products/beauty-shot/status'
*/
ShowBeautyShotGenerationStatusBatchControllerForm.post = (options?: RouteQueryOptions): RouteFormDefinition<'post'> => ({
    action: ShowBeautyShotGenerationStatusBatchController.url(options),
    method: 'post',
})

ShowBeautyShotGenerationStatusBatchController.form = ShowBeautyShotGenerationStatusBatchControllerForm

export default ShowBeautyShotGenerationStatusBatchController